import React from 'react';
import LeafletMap from '../maps/leaflet_intro';


export default function SiteRender(props) {
  if (!(props.sites || props.grants))
    return null;

  return (
    <LeafletMap {...props}/>
  )
}
